document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.querySelector('[data-drawer]');
  const overlay = document.querySelector('[data-drawer-overlay]');

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    overlay?.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay?.setAttribute('aria-hidden', 'true');
  }

  document.querySelector('[data-drawer-open]')?.addEventListener('click', function () {
    drawer?.classList.add('open');
    overlay?.classList.add('open');
    drawer?.setAttribute('aria-hidden', 'false');
    overlay?.setAttribute('aria-hidden', 'false');
  });
  document.querySelectorAll('[data-drawer-close]').forEach(function (button) {
    button.addEventListener('click', closeDrawer);
  });
  overlay?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  document.querySelectorAll('[data-dept-toggle]').forEach(function (button) {
    button.addEventListener('click', function () {
      const box = button.nextElementSibling;
      const isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!isOpen));
      if (box) box.hidden = isOpen;
    });
  });

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = count;
    });
  }

  async function buyNow(button) {
    const form = button.closest('form');
    const variantId = form?.querySelector('[data-variant-id]')?.value || button.getAttribute('data-variant-id');
    if (!variantId) return;
    const quantityInput = form?.querySelector('input[name="quantity"]');
    const quantity = Math.max(1, parseInt(quantityInput?.value || '1', 10));
    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'ADDING...';
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: [{id: Number(variantId), quantity: quantity}]})
      });
      if (!response.ok) throw new Error('Cart add failed');
      const cartResponse = await fetch('/cart.js', {headers: {'Accept': 'application/json'}});
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        updateCartCount(cart.item_count);
      }
      window.location.href = '/cart';
    } catch (error) {
      button.disabled = false;
      button.textContent = original;
      alert('Unable to add this product to the cart. Please try again.');
    }
  }

  document.querySelectorAll('.rz-buy-now').forEach(function (button) {
    button.addEventListener('click', function () { buyNow(button); });
  });

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    const selects = Array.from(form.querySelectorAll('.rz-variant-select'));
    const idInput = form.querySelector('[data-variant-id]');
    const priceEl = form.closest('.rz-product-detail')?.querySelector('[data-product-price]');
    const buyButton = form.querySelector('.rz-buy-now');
    const variants = window.rzProductVariants || [];

    function formatMoney(cents) {
      const amount = (Number(cents) / 100).toFixed(2);
      const format = window.rzProductMoneyFormat || '${{amount}}';
      return format
        .replace(/\{\{\s*amount\s*\}\}/g, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents) / 100)))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(Number(cents) / 100)).replace('.', ','));
    }

    function syncVariant() {
      if (!variants.length || !selects.length) return;
      const values = selects.map(function (select) { return select.value; });
      const match = variants.find(function (variant) {
        return variant.options.every(function (value, index) { return String(value) === String(values[index]); });
      });
      if (!match) {
        if (idInput) idInput.value = '';
        if (buyButton) buyButton.disabled = true;
        return;
      }
      if (idInput) idInput.value = match.id;
      if (buyButton) {
        buyButton.setAttribute('data-variant-id', match.id);
        buyButton.disabled = !match.available;
        buyButton.textContent = match.available ? 'BUY NOW' : 'SOLD OUT';
      }
      const addButton = form.querySelector('button[type="submit"]');
      if (addButton) {
        addButton.disabled = !match.available;
        addButton.textContent = match.available ? 'ADD TO CART' : 'SOLD OUT';
      }
      if (priceEl) priceEl.textContent = formatMoney(match.price);
    }

    selects.forEach(function (select) { select.addEventListener('change', syncVariant); });
    syncVariant();
  });

  document.querySelectorAll('.rz-qty-control').forEach(function (box) {
    const input = box.querySelector('.rz-qty-input');
    const line = Number(box.getAttribute('data-line'));
    let busy = false;

    async function setQuantity(value) {
      if (!line || busy) return;
      const next = Math.max(0, parseInt(value || '0', 10));
      busy = true;
      input.disabled = true;
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({line: line, quantity: next})
        });
        if (!response.ok) throw new Error('Cart update failed');
        window.location.reload();
      } catch (error) {
        input.disabled = false;
        busy = false;
        alert('Unable to update the cart. Please try again.');
      }
    }

    box.querySelectorAll('[data-qty-action]').forEach(function (button) {
      button.addEventListener('click', function () {
        const current = Math.max(0, parseInt(input.value || '1', 10));
        const next = button.getAttribute('data-qty-action') === 'plus' ? current + 1 : Math.max(0, current - 1);
        setQuantity(next);
      });
    });

    input?.addEventListener('change', function () { setQuantity(input.value); });
  });

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('.rz-share-button');
    if (!button) return;
    const url = button.getAttribute('data-share-url') || location.href;
    const title = button.getAttribute('data-share-title') || document.title;
    try {
      if (navigator.share) {
        await navigator.share({title: title, url: new URL(url, location.origin).href});
      } else if (navigator.clipboard) {
        await navigator.clipboard.writeText(new URL(url, location.origin).href);
        button.classList.add('is-copied');
        setTimeout(function () { button.classList.remove('is-copied'); }, 1500);
      }
    } catch (error) {}
  });

  const info = document.getElementById('rz-info-page');
  if (info) {
    const panels = info.querySelectorAll('[data-info-panel]');
    function closeInfo() {
      info.hidden = true;
      panels.forEach(function (panel) { panel.hidden = true; });
      document.querySelectorAll('#MainContent > *').forEach(function (element) { element.hidden = false; });
      document.querySelectorAll('.rz-global-cover,.rz-marketing-wrap,.rz-products-section').forEach(function (element) { element.hidden = false; });
      const url = new URL(location.href);
      url.searchParams.delete('rz_info');
      history.pushState({}, '', url.pathname + url.search + url.hash);
    }
    function openInfo(key) {
      const panel = info.querySelector('[data-info-panel="' + CSS.escape(key) + '"]');
      if (!panel) return;
      document.querySelectorAll('#MainContent > *').forEach(function (element) { element.hidden = true; });
      document.querySelectorAll('.rz-global-cover,.rz-marketing-wrap,.rz-products-section').forEach(function (element) { element.hidden = true; });
      info.hidden = false;
      panels.forEach(function (item) { item.hidden = true; });
      panel.hidden = false;
      info.scrollIntoView({behavior: 'smooth', block: 'start'});
    }
    const key = new URLSearchParams(location.search).get('rz_info');
    if (key) openInfo(key);
    info.querySelector('[data-info-close]')?.addEventListener('click', closeInfo);
    window.addEventListener('popstate', function () {
      const current = new URLSearchParams(location.search).get('rz_info');
      if (current) openInfo(current); else closeInfo();
    });
  }
});

/* Product tabs */
document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('[data-product-tab]');
  if (!tabs.length) return;
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      const key = tab.getAttribute('data-product-tab');
      tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
      document.querySelectorAll('[data-product-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-product-panel') !== key;
        panel.classList.toggle('is-active', !panel.hidden);
      });
    });
  });
});
